<template>
  <div class="test_mark">
    <img src="../../assets/img/caution-sign.svg" alt=""><span>Тест</span>
    <div class="test_hint">
      Це тестовая версія. Маєте запитання чи пропозицію? <a href="https://multiplex.ua/faq#support">Напишіть нам</a>
    </div>
  </div>
</template>

<script>
export default {}
</script>



// WEBPACK FOOTER //
// test-mark.vue?427dbda9